// src/components/CookieBanner.js
import React, { useContext, useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { PrivacyContext } from "../context/PrivacyContext";
import styles from "./CookieBanner.module.css";

const CookieBanner = () => {
  const { cookieConsent, acceptCookies } = useContext(PrivacyContext);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!cookieConsent) {
      const t = setTimeout(() => setVisible(true), 600);
      return () => clearTimeout(t);
    }
  }, [cookieConsent]);

  if (cookieConsent) return null;

  return (
    <div className={`${styles.overlay} ${visible ? styles.visible : ""}`}>
      <div className={styles.accentBar} />
      <div className={styles.inner}>
        <div className={styles.iconWrap}>
          <span className={styles.cookieIcon}>🍪</span>
        </div>
        <div className={styles.textBlock}>
          <p className={styles.heading}>We use cookies</p>
          <p className={styles.body}>
            We use cookies to enhance your experience and analyze our traffic.
            By clicking "Accept", you consent to our use of cookies in accordance
            with our{" "}
            <Link to="/legal/privacy" className={styles.privacyLink}>
              Privacy Policy
            </Link>
            .
          </p>
        </div>
        <div className={styles.actions}>
          <button onClick={acceptCookies} className={styles.acceptBtn}>
            Accept
          </button>
        </div>
      </div>
    </div>
  );
};

export default CookieBanner;